import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    if (!(this.hasContainerTarget)) return

    this.#cacheThumblineInformation()

    if (this.#shouldShowGradient()) {
      const lastVisibleIndex = this.thumbsPerView - 1

      this.#applyGradient(lastVisibleIndex)
    }
  }

  markThumbWithGradient() {
    if (!this.#shouldShowGradient()) return

    const scroll = this.container.scrollLeft
    const firstVisibleIndex = Math.floor(scroll / this.thumbWidth)
    const lastVisibleIndex = firstVisibleIndex + this.thumbsPerView - 1
    const previousLastVisible = this.container.querySelector(".thumbline__last-thumb-gradient")

    if (previousLastVisible) {
      previousLastVisible.classList.remove("thumbline__last-thumb-gradient")
    }

    this.#applyGradient(lastVisibleIndex)
  }

  #applyGradient(thumbIndex) {
    if (thumbIndex >= this.thumbs.length - 1) return

    if (this.thumbs[thumbIndex]) {
      this.thumbs[thumbIndex].classList.add("thumbline__last-thumb-gradient")
    }
  }

  #cacheThumblineInformation() {
    this.container = this.containerTarget
    this.thumbs = this.containerTarget.querySelectorAll(".thumbline__thumb")
    this.thumbWidth = this.thumbs[0]?.offsetWidth || 0
    this.thumbsPerView = Math.floor(this.container.offsetWidth / this.thumbWidth)
  }

  #shouldShowGradient() {
    return this.thumbs.length > this.thumbsPerView
  }
}
